import { Reveal, SectionHeading } from "./Reveal";
import { GALLERY } from "../../data/site";

export const Gallery = () => (
  <section id="galeria" className="bg-mist py-20 lg:py-28" data-testid="gallery-section">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <SectionHeading
        number="05"
        eyebrow="Galeria"
        title="Veja o nosso trabalho"
        subtitle="Um vislumbre do cuidado que dedicamos a cada estofo."
      />

      <div className="mt-14 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {GALLERY.map((item, i) => (
          <Reveal key={item.src} delay={(i % 3) * 0.08}>
            <figure
              data-testid={`gallery-item-${i}`}
              className="group relative overflow-hidden rounded-3xl shadow-[0_4px_24px_rgba(11,25,44,0.06)]"
            >
              <img
                src={item.src}
                alt={item.alt}
                loading="lazy"
                className="aspect-[4/3] w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
              />
              <div
                className="absolute inset-0 bg-gradient-to-t from-navy/70 via-navy/10 to-transparent opacity-80 transition-opacity duration-500 group-hover:opacity-100"
                aria-hidden="true"
              />
              <figcaption className="absolute bottom-4 left-4 rounded-full bg-white/15 px-4 py-1.5 text-xs font-semibold uppercase tracking-[0.14em] text-white backdrop-blur-md">
                {item.label}
              </figcaption>
            </figure>
          </Reveal>
        ))}
      </div>

    </div>
  </section>
);
